import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Interest } from 'src/app/interfaces/interest';
import { InterestService } from 'src/app/services/interest.service';
import { OverlayService } from 'src/app/services/overlay.service';

@Component({
  selector: 'app-edit-interest',
  templateUrl: './edit-interest.component.html',
  styleUrls: ['./edit-interest.component.scss']
})
export class EditInterestComponent implements OnInit {
  /**
   * The Form to edit the Interest
   */
  editForm: UntypedFormGroup;
  /**
   * Is the Page loading
   */
  finishedLoading: boolean = false;
  /**
   * The current Interest => set via URL
   */
  currentInterest: Interest;
  /**
   * The States an Interest can have
   */
  public stateOptions = [
    { value: 'ACTIVE', viewValue: 'Aktiv' },
    { value: 'DELETED', viewValue: 'Gelöscht' },
  ]
  /**
   * constructor
   * Init the Forms 
   * Get the Filterest via the URL
   * @param interestService 
   * @param fb 
   * @param overlayService 
   * @param router 
   * @param route 
   */
  constructor(
    private interestService: InterestService,
    private fb: UntypedFormBuilder,
    private overlayService: OverlayService,
    private router: Router,
    private route: ActivatedRoute) {
    this.editForm = this.fb.group({
      name: ['', [Validators.required]],
      state: ['', [Validators.required]]
    })
    this.route.params.subscribe(params => {
      this.interestService.getAllInterests().subscribe({
        next: (fromGet: Array<Interest>) => {
          this.currentInterest = fromGet.filter(interest => interest.publicId == params['id'])[0]
          this.editForm.patchValue({
            name: this.currentInterest.name,
            state: this.currentInterest.state
          });
          this.finishedLoading = true;
        },
        error: error => {
          console.log("error: ", error);
          this.overlayService.openErrorDialog("Fehler beim Laden", "Versuchen Sie es bitte später noch einmal. Sollte das Problem nicht in absehbarer Zeit behoben sein, schreiben Sie uns eine E-Mail an: support@plusservices.de", "Zurück")
        }
      })
    })
  }
  /**
   * ngOnInit
   */
  ngOnInit(): void {

  }
  /**
   * Edit the Interest
   * @returns 
   */
  editInterest() {
    this.editForm.markAllAsTouched();
    if (this.editForm.invalid) {
      return;
    }
    this.currentInterest.name = this.editForm.value.name;
    this.currentInterest.state = this.editForm.value.state;
    this.interestService.editInterest(this.currentInterest).subscribe(val => {
      this.router.navigateByUrl('caseworker/interest');
      this.overlayService.openSnackBar("Interesse erfolgreich bearbeitet!");
    })
  }
}
